const config = {
  // V2.0 production backend (Railway, project "merry-truth" / env "production").
  // Was the legacy DreamHost/DigitalOcean backend "https://lanis.api.golanis.com/";
  // repointed 2026-10-09 for the Railway cutover. At DNS cutover, lanis.golanis.com
  // serves the frontend built with REACT_APP_ENV_TARGET=production (this file).
  serviceHost: "https://lanis-tierone-tier-one-api-production-a094.up.railway.app/",
  // Dedicated credit-relay URL (Railway). Set this to the relay's public URL
  // once it is deployed; until then credit falls back to serviceHost.
  creditHost: "https://divine-creation-production-2aa4.up.railway.app/",
  stripePublicApiKey: "pk_live_EQD9DT3DjcNw01hhE6Sf0fzF00BGBPM14u"
};

export default config;
